import { history } from '@umijs/max';
import { useMemo } from 'react';

export const useLocationCheck = () => {
  return useMemo(
    () => ({
      isMyProduct: history.location.pathname.startsWith('/myproduct'),
    }),
    [history.location.pathname],
  );
};
